export const lenisStore = { current: null };

export const APP_START = performance.now();

export const introDelay = () => Math.max(0.15, 1.5 - (performance.now() - APP_START) / 1000);

export const scrollToTarget = (target) => {
  const l = lenisStore.current;
  if (l) l.scrollTo(target, { offset: -24, duration: 1.5 });
  else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
};
